import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root',
})
export class StateService {

  constructor(
    private readonly commonService: CommonService,
  ) {}
  private companyIdSubject = new BehaviorSubject<number | null>(
    this.convertToNumber(localStorage.getItem('companyId') ? this.commonService.Decrypt(localStorage.getItem('companyId')!) : '')
  );
  private yearIdSubject = new BehaviorSubject<number | null>(
    this.convertToNumber(localStorage.getItem('yearId') ? this.commonService.Decrypt(localStorage.getItem('yearId')!) : '')
  );

  private menuSubject = new BehaviorSubject<any>(
    localStorage.getItem('menuRowData')
  );

  private triggerEventSource = new Subject<void>();
  triggerEvent$ = this.triggerEventSource.asObservable();

  private triggerEventCompany = new Subject<void>();
  triggerEventCompany$ = this.triggerEventCompany.asObservable();

  companyId$ = this.companyIdSubject.asObservable();
  yearId$ = this.yearIdSubject.asObservable();
  IsRowData$ = this.menuSubject.asObservable();

  setCompanyId(companyId: string) {
    let numberId = this.convertToNumber(companyId);
    if(numberId == null){
      numberId = 0;
    }
    const EncryptCompanyId = this.commonService.Encrypt(String(numberId))
    localStorage.setItem('companyId',EncryptCompanyId);
    this.companyIdSubject.next(numberId);
  }

  setYearId(yearId: string) {
    if(yearId == '')
    {
      localStorage.removeItem('yearId');
      this.yearIdSubject.next(null);
    }
    else
    {
      let numberId = this.convertToNumber(yearId);
      if(numberId == null){
        numberId = 0;
      }
      const EncryptYearId = this.commonService.Encrypt(String(numberId))
      localStorage.setItem('yearId', EncryptYearId);
      this.yearIdSubject.next(numberId);
    }

  }

  setMenuRowData(IsRowData: any){
    localStorage.setItem('menuRowData', IsRowData);
    this.menuSubject.next(IsRowData);
  }

  getCompanyId() {
    return this.companyIdSubject.value;
  }

  getYearId() {
    return this.yearIdSubject.value;
  }

  getMenuRowData(){
    return this.menuSubject.value;
  }
  convertToNumber(value: string | null): number | null {
    return value ? Number(value) : null;
  }

  triggerOtherComponentMethod() {
    this.triggerEventSource.next();
  }

  triggerCompanyMethod() {
    this.triggerEventCompany.next();
  }

  clearAllData() {
    this.setCompanyId('');
    this.setYearId('');
  }
}
